<template>
    <div>
        <bc-tooltip v-if="!noButton && hasPerm('nonconformance.create')" v-bind="$attrs" :class="{ 'hidden-sm-and-down': !permanent }">
            <!-- single add button with customizeable tooltip -->
            <template slot="activator">
                <v-btn
                    :icon="type == 'icon'"
                    :class="type == 'button' ? 'mx-2' : ''"
                    :style="type == 'button' ? 'min-width: 0;' : ''"
                    :color="type == 'button' && buttonColor ? buttonColor : ''"
                    @mouseup.left="showNonconformance(item ? item : null)"
                >
                    <v-icon class="material-icons-outlined" :color="iconColor ? iconColor : ''">{{ icon }}</v-icon>
                </v-btn>
            </template>
            {{ tooltip ? tooltip : $t("lang.create_nonconformance") }}
        </bc-tooltip>
        <bc-dialog :value="nonconformance_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{
                        currObjField("nonconformance_id")
                            ? currObjField("editable") == "0"
                                ? $t("lang.view_nonconformance")
                                : $t("lang.edit_nonconformance")
                            : $t("lang.add_nonconformance")
                    }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeNonconformanceDialog"
                        :dialog-status="nonconformance_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="nonconformance" @submit.prevent>
                        <v-container grid-list-form>
                            <v-layout row wrap :class="{ 'prevent-click': currObjField('nonconformance_id') && currObjField('editable') == '0' }">
                                <v-flex xs12 style="height: 100%">
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance.stop_loading"
                                                :label="`${$t('lang.stop_loading')}`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance.stop_loading')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="nonconformance.nonconformance_type_id"
                                                :label="`${$t('lang.nonconformance_type')} *`"
                                                :items="nonconformance_types"
                                                item-value="nonconformance_type_id"
                                                item-text="type"
                                                :rules="ifValid('nonconformance.nonconformance_type_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance.notify_supervisor"
                                                :label="`${$t('lang.notify_supervisor')}`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance.notify_supervisor')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs6 v-if="nonconformance.notify_supervisor == 0">
                                            <v-text-field
                                                v-model="nonconformance.not_notified_reason"
                                                :label="`${$t('lang.not_notified_reason')}`"
                                                :rules="ifValid('nonconformance.not_notified_reason')"
                                            >
                                            </v-text-field>
                                        </v-flex>
                                        <v-flex xs6 v-if="nonconformance.notify_supervisor == 1">
                                            <bc-autocomplete
                                                v-model="nonconformance.supervisor_id"
                                                :label="`${$t('lang.supervisor_name')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.supervisor_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance.fc"
                                                :label="`${$t('lang.fc')}`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance.fc')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-if="nonconformance.fc == 0"
                                                v-model="nonconformance.not_fc_reason"
                                                :label="`${$t('lang.not_fc_reason')}`"
                                                :rules="ifValid('nonconformance.not_fc_reason')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance.qc_hold"
                                                :label="`${$t('lang.qc_hold')}`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance.qc_hold')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                v-if="nonconformance.qc_hold == 0"
                                                v-model="nonconformance.not_qc_reason"
                                                :label="`${$t('lang.not_qc_reason')}`"
                                                :rules="ifValid('nonconformance.not_qc_reason')"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="nonconformance.prod_shift_super_id"
                                                :label="`${$t('lang.prod_shift_super')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.prod_shift_super_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="nonconformance.prod_super_id"
                                                :label="`${$t('lang.prod_super')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.prod_super_id')"
                                            ></bc-autocomplete>
                                        </v-flex>

                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="nonconformance.prod_asst_mgr_id"
                                                :label="`${$t('lang.prod_asst_mgr')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.prod_asst_mgr_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="nonconformance.prod_mgr_id"
                                                :label="`${$t('lang.prod_mgr')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.prod_mgr_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-switch
                                                v-model="nonconformance.charge"
                                                :label="nonconformance.charge == '1' ? $t('lang.charge_yes') : $t('lang.charge_no')"
                                                true-value="1"
                                                false-value="0"
                                            ></v-switch>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-autocomplete
                                                v-model="nonconformance.qc_mgr_id"
                                                :label="`${$t('lang.qc_mgr')}`"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance.qc_mgr_id')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                small
                                                :label="`${$t('lang.suspect_qty_found')}`"
                                                v-model="nonconformance.nonconformance_qty"
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6>
                                            <v-textarea
                                                v-model="nonconformance.description"
                                                :label="`${$t('lang.description')} *`"
                                                auto-grow
                                                rows="1"
                                                :rules="ifValid('nonconformance.description')"
                                            ></v-textarea>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        v-if="currObjField('nonconformance_id') && currObjField('editable') == '1' && hasPerm('nonconformance.delete')"
                        color="error"
                        @mouseup.left="$refs.delete_nonconformance.openDialog()"
                        >{{ $t("lang.delete") }}</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeNonconformanceDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        v-if="!currObjField('nonconformance_id') || (currObjField('editable') == '1' && hasPerm('nonconformance.update'))"
                        color="success"
                        @mouseup.left="modifyNonconformance(currObjField('nonconformance_id') ? 'patch' : 'post', currObjField('nonconformance_id'))"
                        >{{ $t("lang.save") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <bc-dialog :value="nonconformance_hold_tag_dialog" max-width="800">
            <v-card>
                <v-card-title>
                    <span class="headline">{{
                        nonconformance_hold_tag && nonconformance_hold_tag.hold_tag_id
                            ? currObjField("editable") == "0"
                                ? $t("lang.view_nonconformance_hold_tag")
                                : $t("lang.edit_nonconformance_hold_tag")
                            : $t("lang.add_nonconformance_hold_tag")
                    }}</span>
                    <v-spacer></v-spacer>
                    <bc-btn-dialog-close
                        @invoke-method="invokeMethod($event)"
                        action="closeNonconformanceHoldTagDialog"
                        :dialog-status="nonconformance_hold_tag_dialog"
                    ></bc-btn-dialog-close>
                </v-card-title>
                <v-card-text>
                    <v-form ref="form_nonconformance_hold_tag" @submit.prevent>
                        <v-container grid-list-form>
                            <v-layout row wrap :class="{ 'prevent-click': currObjField('nonconformance_id') && currObjField('editable') == '0' }">
                                <v-flex xs12 style="height: 100%">
                                    <v-layout row wrap>
                                        <v-flex xs6>
                                            <v-text-field
                                                :label="`${$t('lang.internal_id')}`"
                                                :value="current_obj && current_obj.internal_id ? current_obj.internal_id : '---'"
                                                disabled
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6> </v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                :label="`${$t('lang.part_number')}`"
                                                :value="current_obj && current_obj.customer_part_number ? current_obj.customer_part_number : '---'"
                                                disabled
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6></v-flex>
                                        <v-flex xs6>
                                            <v-text-field
                                                :label="`${$t('lang.customer')}`"
                                                :value="current_obj && current_obj.company ? current_obj.company : '---'"
                                                disabled
                                            ></v-text-field>
                                        </v-flex>
                                        <v-flex xs6></v-flex>
                                        <v-flex xs6>
                                            <h3><strong>QC Dept. use only</strong></h3>
                                        </v-flex>
                                        <v-flex xs6></v-flex>
                                        <v-flex xs6>
                                            <v-checkbox label="QC verified abnormal condition" hide-details></v-checkbox>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-model="nonconformance_hold_tag.verified_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.verified_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-model="nonconformance_hold_tag.verified_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.verified_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <h3><strong>Request to Production</strong></h3>
                                        </v-flex>
                                        <v-flex xs6>
                                            <h3><strong>Production Dept. use only</strong></h3>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance_hold_tag.nine_point_submission"
                                                :label="`${$t('lang.nine_point_submission')} *`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance_hold_tags.nine_point_submission')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-model="nonconformance_hold_tag.nine_point_submission_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.nine_point_submission_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-model="nonconformance_hold_tag.nine_point_submission_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.nine_point_submission_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance_hold_tag.strip_chart"
                                                :label="`${$t('lang.strip_chart')} *`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance_hold_tags.strip_chart')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-model="nonconformance_hold_tag.strip_chart_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.strip_chart_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-model="nonconformance_hold_tag.strip_chart_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.strip_chart_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance_hold_tag.recipe_sheet"
                                                :label="`${$t('lang.recipe_sheet')} *`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance_hold_tags.recipe_sheet')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-model="nonconformance_hold_tag.recipe_sheet_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.recipe_sheet_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-model="nonconformance_hold_tag.recipe_sheet_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.recipe_sheet_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <bc-select
                                                v-model="nonconformance_hold_tag.process_sheet"
                                                :label="`${$t('lang.process_sheet')} *`"
                                                :items="[
                                                    { value: '1', text: $t('lang.yes') },
                                                    { value: '0', text: $t('lang.no') },
                                                ]"
                                                item-value="value"
                                                item-text="text"
                                                :rules="ifValid('nonconformance_hold_tags.process_sheet')"
                                            >
                                            </bc-select>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-model="nonconformance_hold_tag.process_sheet_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.process_sheet_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-model="nonconformance_hold_tag.process_sheet_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.process_sheet_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                        <v-flex xs6>
                                            <h3><strong>QC Dept. use only</strong></h3>
                                        </v-flex>
                                        <v-flex xs6></v-flex>
                                        <v-flex xs6>
                                            <v-checkbox label="Customer Contacted" hide-details></v-checkbox>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-date-picker
                                                v-model="nonconformance_hold_tag.customer_contacted_date"
                                                :label="$t('lang.date')"
                                                :rules="ifValid('nonconformance_hold_tags.customer_contacted_date')"
                                            ></bc-date-picker>
                                        </v-flex>
                                        <v-flex xs3>
                                            <bc-autocomplete
                                                v-model="nonconformance_hold_tag.customer_contacted_by"
                                                :label="$t('lang.by')"
                                                :items="people_options"
                                                item-value="user_id"
                                                item-text="combined_name"
                                                :rules="ifValid('nonconformance_hold_tags.customer_contacted_by')"
                                            ></bc-autocomplete>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn v-if="nonconformance_hold_tag.hold_tag_id != ''" color="primary" @click="showPrinter(nonconformance_hold_tag.hold_tag_id)"
                        >Print</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn flat @mouseup.left="closeNonconformanceHoldTagDialog()">{{ $t("lang.cancel") }}</v-btn>
                    <v-btn
                        v-if="!currObjField('nonconformance_id') || (currObjField('editable') == '1' && hasPerm('nonconformance.update'))"
                        color="success"
                        @mouseup.left="saveNonconformanceHoldTags()"
                        >{{ $t("lang.save") }}</v-btn
                    >
                </v-card-actions>
            </v-card>
        </bc-dialog>
        <delete-confirmation-dialog
            ref="delete_nonconformance"
            :heading="$t('lang.delete_nonconformance')"
            :message="$t('lang.confirm_delete_message')"
            @onConfirm="modifyNonconformance('delete', currObjField('nonconformance_id'))"
        ></delete-confirmation-dialog>
        <bc-modal-print ref="print" @close-method="(file_name = null), $refs.print.close()" :file-name="file_name" :no-button="true"></bc-modal-print>
    </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";

export default {
    props: {
        tooltip: {
            type: String,
        },
        permanent: {
            type: Boolean,
            default: false,
        },
        noButton: {
            type: Boolean,
            default: false,
        },
        icon: {
            type: String,
            default: "report",
        },
        entity_object: {
            // object name matching first portion of api url i.e. people | me | customers
            type: String,
        },
        entity_id: {
            // if object is not 'me', use id in urlObject
            type: [String, Number],
        },
        stateProperty: {
            type: String,
        },
        type: {
            type: String,
            default: "icon",
        },
        buttonColor: {
            type: String,
            default: null,
        },
        iconColor: {
            type: String,
            default: null,
        },
        maxValue: {
            type: [String, Number],
            default: null,
        },
        repackDetailId: {
            type: String,
            default: null,
        },
        item: {
            type: Object,
            default: null,
        },
    },
    data() {
        return {
            nonconformance_dialog: false,
            nonconformance_hold_tag_dialog: false,
            nonconformance: {
                nonconformance_type_id: "",
                nonconformance_qty: "",
                description: "",
                reason_code_id: "",
                charge: 0,
                created_by: "",
                editable: "",
                stop_loading: "",
                notify_supervisor: "",
                not_notified_reason: "",
                fc: "",
                not_fc_reason: "",
                qc_hold: "",
                not_qc_reason: "",
                prod_shift_super: "",
                prod_super: "",
                prod_asst_mgr: "",
                prod_mgr: "",
                qc_mgr: "",
                reason: "",
                object_id: "",
                object_name: "",
            },
            current_obj: null,
            nonconformance_hold_tag: {
                hold_tag_id: "",
                nonconformance_id: "",
                verified_date: "",
                verified_by: "",
                nine_point_submission: "",
                nine_point_submission_date: "",
                nine_point_submission_by: "",
                strip_chart: "",
                strip_chart_date: "",
                strip_chart_by: "",
                recipe_sheet: "",
                recipe_sheet_date: "",
                recipe_sheet_by: "",
                process_sheet: "",
                process_sheet_date: "",
                process_sheet_by: "",
                customer_contacted: "",
                customer_contacted_date: "",
                customer_contacted_by: "",
            },
            file_name: "",
        };
    },
    computed: {
        ...mapState({
            rules_nonconformance: (state) => state.validation.rules_nonconformance,
            nonconformance_types: (state) => state.nonconformance.nonconformance_types,
            current_repack: (state) => state.repack.repack,
            packages: (state) => state.repack.packages,
            people_options: (state) => state.people.person_options,
            rules_nonconformance_hold_tags: (state) => state.nonconformance_hold_tags.rules_nonconformance_hold_tags,
        }),
        currObjField() {
            return (field) => {
                return this.current_obj && field && this.current_obj[field] ? this.current_obj[field] : "";
            };
        },
    },
    methods: {
        ...mapActions(["startLoader", "finishLoader", "fetchPeople", "saveNonconformanceHoldTag", "fetchNonconformanceHoldTag", "printNonconformanceHoldTag"]),
        ...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
        closeNonconformanceDialog() {
            this.nonconformance_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
            if (this.$refs.delete_nonconformance) this.$refs.delete_nonconformance.close();
        },
        getNonconformances() {
            this.startLoader();
            this.$store
                .dispatch("fetchNonconformance", {
                    url: "nonconformance",
                    method: "get",
                    stateProperty: "nonconformances",
                    commit: true,
                    body: JSON.parse(JSON.stringify(this.$route.query)),
                })
                .then((data) => {
                    if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
                })
                .finally(() => {
                    this.nonconformance_dialog = false;
                    this.$store.commit("toggleModalLoader", false);
                    this.$store.commit("validationOff");
                    this.finishLoader(true);
                });
        },
        modifyNonconformance(method = null, id = null) {
            this.nonconformance.object_id = this.entity_id;
            this.nonconformance.object_name = this.entity_object;
            let body = this.prepForm(this.nonconformance, this.rules_nonconformance);
            if (method) {
                this.$store.commit("validationOn");
                this.$nextTick(() => {
                    if (method == "delete" || this.validateForm("nonconformance")) {
                        if (this.repackDetailId) this.nonconformance.repack_detail_id = this.repackDetailId;
                        this.$store.commit("toggleModalLoader", true);
                        this.$store
                            .dispatch("fetchNonconformance", {
                                pk: "nonconformance_id",
                                id: id,
                                url: `nonconformance/${id ? id : ""}`,
                                method: method,
                                stateProperty: this.stateProperty ? this.stateProperty : "nonconformances",
                                dataProperty: "nonconformance",
                                mutate: method != "post",
                                body: body,
                            })
                            .then((data) => {
                                if (data && data.code == "200") {
                                    this.closeNonconformanceDialog();
                                    if (this.repackDetailId) {
                                        let details = this.current_repack.repack_details;
                                        let update_index = (details || []).findIndex((obj) => obj.repack_detail_id == this.repackDetailId);
                                        if (update_index >= 0) {
                                            // update detail row
                                            details[update_index].total_removed = `${
                                                +details[update_index].total_removed + +this.nonconformance.nonconformance_qty
                                            }`;
                                            details[update_index].qty = `${+details[update_index].qty - +this.nonconformance.nonconformance_qty}`;
                                            this.$store.commit("commitRepack", {
                                                property: "repack.repack_details",
                                                with: details,
                                            });
                                            // update list view
                                            if ((this.packages || []).length > 0) {
                                                this.$store.commit("mutateRepack", {
                                                    pk: "repack_id",
                                                    id: details[update_index].repack_id,
                                                    method: "patch",
                                                    property: "packages",
                                                    with: {
                                                        repack_qty: `${+details[update_index].qty - +this.nonconformance.nonconformance_qty}`,
                                                    },
                                                });
                                            }
                                        }
                                    }
                                } else {
                                    this.$store.commit("toggleModalLoader", false);
                                }
                            });
                    }
                });
            }
        },
        getNonconformanceTypes() {
            this.$store.dispatch("fetchNonconformance", {
                url: "nonconformance_types",
                method: "get",
                stateProperty: "nonconformance_types",
                commit: true,
            });
        },
        showNonconformance(item = null) {
            this.current_obj = item;

            if (this.$refs.nonconformance) this.$refs.nonconformance.reset();
            if (this.nonconformance_types == null) this.getNonconformanceTypes();
            this.nonconformance_dialog = true;
            this.assignObj(this.nonconformance, item, this.rules_nonconformance);

            this.$nextTick(() => {
                if (item == null) {
                    this.nonconformance.object_name = this.entity_object;
                    this.nonconformance.object_id = this.entity_id;
                }

                if (this.people_options.length == 0) this.fetchPeople({ body: { options: 1, login_type: 1 } });
            });
        },
        showNonconformanceHoldTag(getHoldTag = false) {
            if (getHoldTag) {
                this.fetchNonconformanceHoldTag({ id: this.current_obj.hold_tag_id }).then((data) => {
                    if (data && data.nonconformance_hold_tags) {
                        this.assignObj(this.nonconformance_hold_tag, data.nonconformance_hold_tags, this.rules_nonconformance_hold_tags);
                    }
                });
            }

            this.$nextTick(() => {
                this.nonconformance_hold_tag_dialog = true;
                if (this.nonconformance_hold_tag.nonconformance_id == "" || this.nonconformance_hold_tag.nonconformance_id == null) {
                    this.nonconformance_hold_tag.nonconformance_id = this.current_obj.nonconformance_id;
                }
                if (this.people_options.length == 0) this.fetchPeople({ body: { options: 1, login_type: 1 } });
            });
        },
        closeNonconformanceHoldTagDialog() {
            if (this.$refs.form_nonconformance_hold_tag) this.$refs.form_nonconformance_hold_tag.reset();
            this.nonconformance_hold_tag_dialog = false;
            this.$store.commit("validationOff");
            this.$store.commit("toggleModalLoader", false);
        },
        saveNonconformanceHoldTags() {
            this.validationOn();
            this.$nextTick(() => {
                if (this.validateForm("form_nonconformance_hold_tag")) {
                    let body = this.prepForm(this.nonconformance_hold_tag, this.rules_nonconformance_hold_tags);

                    this.saveNonconformanceHoldTag({
                        body: body,
                    }).then((data) => {
                        if (data && data.code == "200") {
                            if (this.enableEditModal) {
                                this.getNonconformanceHoldTags();
                                this.closeNonconformanceHoldTagDialog();
                            } else {
                                this.$router.push({ name: "nonconformance_hold_tag", params: { id: data.hold_tag_id } });
                            }
                        } else {
                            //this.toggleModalLoader(false);
                        }
                    });
                }
            });
        },
        showPrinter(hold_tag) {
            // this.startLoader();
            this.$refs.print.openDialog();

            this.printNonconformanceHoldTag({ id: hold_tag }).then((data) => {
                if (typeof data != "undefined" && data.hold_tags) {
                    this.file_name = data.hold_tags.file_name;
                } else {
                    this.file_name = "";
                    this.$refs.print.close();
                    this.createAlert();
                }
            });
        },
    },
};
</script>
